import { useState } from "react";

interface NegativeKeywordProps {
    keywords: string[];
    editMode: boolean;
    isEditable: boolean;
    onChange: (value: string[]) => void;
}

export default function NegativeKeywordSection({
    keywords,
    editMode,
    isEditable,
    onChange,
}: NegativeKeywordProps) {
    const [input, setInput] = useState("");

    const handleAdd = () => {
        const newKeywords = input
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k && !keywords.includes(k));

        if (newKeywords.length === 0) return;

        onChange([...keywords, ...newKeywords]);
        setInput("");
    };

    const handleRemove = (word: string) => {
        onChange(keywords.filter((k) => k !== word));
    };

    return (
        <div className="w-full rounded-xl p-2">
            <div className="flex flex-wrap gap-2">
                {keywords.length === 0 ? (
                    <div className="px-3 py-1 rounded-md bg-orange-500 text-white border border-orange-500 text-sm">
                        —
                    </div>
                ) : (
                    keywords.map((keyword) => (
                        <div
                            key={keyword}
                            className="px-3 py-1 rounded-md bg-orange-500 text-white border border-orange-500 text-sm flex items-center gap-1"
                        >
                            {keyword}
                            {editMode && isEditable && (
                                <button
                                    type="button"
                                    onClick={() => handleRemove(keyword)}
                                    className="ml-1 text-white hover:text-gray-200"
                                >
                                    x
                                </button>
                            )}
                        </div>
                    ))
                )}
            </div>

            {editMode && isEditable && (
                <div className="flex gap-2 mt-2">
                    <input
                        type="text"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), handleAdd())}
                        placeholder="Type keywords separated by commas or press Enter"
                        className="border rounded px-3 py-2 w-full"
                    />
                    <button
                        type="button"
                        onClick={handleAdd}
                        className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600"
                    >
                        Add
                    </button>
                </div>
            )}
        </div>
    );
}
